import { jsx as _jsx } from "react/jsx-runtime";
import { useNavigate } from "react-router-dom";
import styles from "./link.module.css";
export const LinkContainer = ({ text, link, isExternal, }) => {
    const navigate = useNavigate();
    const handleClick = (e) => {
        e.preventDefault();
        if (isExternal) {
            window.open(link, "_blank", "noopener,noreferrer");
        }
        else {
            navigate(link);
        }
    };
    return (_jsx("a", Object.assign({ href: link, onClick: handleClick, className: styles.link, title: text, "data-testid": `link-${text.toLowerCase().replace(/\s+/g, "-")}` }, { children: text })));
};
